<template>
  <card>
    <template #header>
      <h2 class="font-medium text-blue dark:text-white">
        1L non-transfer attrition after {{ active.academic_year }}-{{ active.academic_year-1999 }} AY
      </h2>
    </template>
    <div class="flex flex-col justify-between h-full">
      <div class="leading-none p-1">
        <div class="inline-flex rounded-lg gap-1 p-1">
          <l-button
            v-for="tab in tabs"
            :key="tab"
            class="py-1 px-2 text-left rounded-md border items-baseline hover:text-orange"
            :class="selectedTab == tab ? 'bg-orange-50 border-orange-100 text-orange' : 'text-blue dark:text-white border-transparent'"
            @click="()=> selectTab(tab)"
          >
            <div class="text-xl font-semibold">
              {{ tabValues[tab] }}%
            </div>
            <div class="text-sm whitespace-nowrap text-gray-500">
              {{ tabNames[tab] }} <span class="hidden sm:inline">1Ls</span>
            </div>
          </l-button>
        </div>
      </div>
      <sparkline
        :id="selectedTab"
        :color="colors.orange[400]"
        :options="options"
        :max="30"
        title="Attrition"
        size="md"
        class="h-[90px] md:h-full"
        hide-text
      />
    </div>
  </card>
</template>

<script setup>
import Card from "@/components/cards/Card.vue"
import LButton from "@/components/buttons/LButton.vue"
import Sparkline from "@/components/sparklines/Sparkline.vue"
import colors from "@/colors"
import { computed, ref } from "vue"

const props = defineProps({
  attrition: { type: Array, required: true },
  id: { type: String, required: true },
})

const tabs = ["all", "white", "minority"]
const tabNames = {
  all: "all",
  white: "white",
  minority: "non-white",
}
const selectedTab = ref(tabs[0])
const firstYear = computed(() => props.attrition[0].academic_year)
const latestYear = computed(() => props.attrition[props.attrition.length - 1].academic_year)
const year = ref(latestYear.value)
const active = computed(() => props.attrition.find((a) => a.academic_year == year.value))

const tabValues = computed(() => ({
  all: (active.value.nontransfer_all).toFixed(1),
  white: (active.value.nontransfer_white).toFixed(1),
  minority: (active.value.nontransfer_minority).toFixed(1),
}))

const selectTab = (newTab) => {
  selectedTab.value = newTab
}

const options = computed(() => {
  return {
    series: [
      {
        type: "areaspline",
        name: "attrition",
        data: props.attrition.map(a => a[`nontransfer_${selectedTab.value}`]),
        point: {
          events: {
            mouseOver() {
              year.value = this.x + firstYear.value
            },
          },
        },
      },
    ],
  }
})
</script>
